import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    // null = loading | true = logged in | false = logged out
    const [isLoggedIn, setIsLoggedIn] = useState(null);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const savedUser = localStorage.getItem("studentUser");
        const token = localStorage.getItem("token");

        if (savedUser && token) {
            setUser(JSON.parse(savedUser));
            setIsLoggedIn(true);
        } else {
            setIsLoggedIn(false);
        }
    }, []);

    const loginUser = (userData, token) => {
        localStorage.setItem("studentUser", JSON.stringify(userData));
        if (token) localStorage.setItem("token", token);
        setUser(userData);
        setIsLoggedIn(true);
    };

    const logoutUser = () => {
        localStorage.removeItem("studentUser");
        localStorage.removeItem("token");
        localStorage.removeItem("userType");
        localStorage.removeItem("isLoggedIn");
        localStorage.removeItem("selectedCourse");
        setUser(null);
        setIsLoggedIn(false);
    };

    const updateUser = (userData) => {
        const updatedUser = { ...user, ...userData };
        localStorage.setItem("studentUser", JSON.stringify(updatedUser));
        setUser(updatedUser);
    };

    return (
        <AuthContext.Provider value={{ user, isLoggedIn, login: loginUser, logout: logoutUser, updateUser }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);

